import { transformDocumentFieldFilter } from '@dealstack/frontend/app/pages/Project/MIP/utils/transformDocumentFieldFilter';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import {
	BaseQuickFiltersDto,
	BaseSortByDto,
	InvestmentProgrammeDocumentsFieldFilterQueryDto,
	PaginationDto,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { Button } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { InvestmentProgrammeDocumentsDataOperations } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/Documents.utils.types';

const bulkDownloadMipDocumentsExcelRequest = async (options: {
	dealId: string;
	programmeId: string;
	dataOperations: InvestmentProgrammeDocumentsDataOperations;
}) => {
	const { dealId, programmeId, dataOperations, ...queryOptions } = options;

	const transformedFieldFilter = transformDocumentFieldFilter(dataOperations.filter);

	const queryString: {
		pagination?: PaginationDto;
		sortBy?: BaseSortByDto;
		fieldFilter?: InvestmentProgrammeDocumentsFieldFilterQueryDto;
		quickFilters?: BaseQuickFiltersDto;
	} = {
		pagination: dataOperations.pagination,
		sortBy: dataOperations.sortBy?.[0] as BaseSortByDto,
		fieldFilter: transformedFieldFilter,
		quickFilters: dataOperations.quickFilters,
	};

	const response = await makeRequest<ApiV1.Response<string>>({
		endpoint: formatUnicorn(
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_EXPORT_TO_EXCEL_POST,
			{
				dealId,
				programmeId,
			}
		),
		method: HTTP_METHOD.POST,
		queryString,
		...queryOptions,
	});

	return response;
};

export const useBulkDownloadDocumentsExcel = () => {
	const tMipManage = useTranslationMipManage();
	const navigate = useNavigate();
	return useMutation({
		mutationFn: bulkDownloadMipDocumentsExcelRequest,
		onSuccess: () => {
			showToastV2({
				title: tMipManage('modals.bulk-download.title'),
				state: 'success',
				message: (
					<div>
						<p>{tMipManage('modals.bulk-download.async-message')}</p>
						<Button
							variant="white"
							onClick={() => navigate('/exports', { replace: true })}
						>
							{tMipManage('modals.bulk-download.go-button')}
						</Button>
					</div>
				),
			});
		},
	});
};
